import React from 'react';
import Styles from './BlogPost.module.less';
import { PortableText } from '../../../bound/landingPage/PortableText';
import { ControllableVideo } from '../../../bound/landingPage/ControllableVideo';
import { Table } from './Table';
import { BlogPostImage } from '../../../bound/landingPage/BlogPost';
import { SanityBlock } from '../../../lib/landingPage';
import { classes } from '../../../lib';
import { BlogBodyExternalLink } from '../BlogBodyExternalLink';

export type BlogTakeawayProps = {
    value: {
        title: string;
        takeaways: SanityBlock;
        color: string;
    };
};

export const BlogTakeaway = ({ value }: BlogTakeawayProps): JSX.Element => {
    return (
        <div className={classes(Styles.takeaways, Styles[value.color])}>
            {value.title && <h2>{value.title}</h2>}
            <PortableText
                value={value.takeaways}
                components={{
                    types: {
                        table: Table,
                        img: BlogPostImage,
                        video: ControllableVideo,
                    },
                    marks: {
                        link: BlogBodyExternalLink,
                    },
                }}
            />
        </div>
    );
};
